import { Schema } from '@bingads-webui-react/overreact';

const schemaToModelMapping = {
  user: 'user',
  customer: 'customer',
  account: 'account',
  sub_geography: 'sub_geography',
  time_zones: 'time_zones',
  countries: 'countries',
  currencies: 'currencies',
  currency_countries_mappings: 'currency_countries_mappings',
  country_currencies_mappings: 'country_currencies_mappings',
  validate_address: 'validate_address',
  sign_up: 'sign_up',
  estimate_taxes: 'estimate_taxes',
  top_up_limit: 'top_up_limit',
  offline_payment_instructions: 'offline_payment_instructions',
  create_expert_from_smart: 'create_expert_from_smart',
  payment_instrument: 'payment_instrument',
  get_coupon_details: 'get_coupon_details',
  get_coupon_string_for_signup: 'get_coupon_string_for_signup',
  get_coupon_valid_for_customer_website: 'get_coupon_valid_for_customer_website',
  save_coupon_string_for_signup: 'save_coupon_string_for_signup',
};

export const schema = new Schema(schemaToModelMapping, () => { });
